<script>
import get from 'lodash/get'

export default {
  name: 'AddressAutocomplete',
  props: {
    value: {
      type: [Object, String],
      required: false,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      loading: false,
      options: [],
    }
  },
  computed: {
    selected: {
      get() {
        return get(this.value, 'name')
      },
      set(name) {
        this.$emit('input', { name })
      },
    },
    autocomplete2() {
      if (window.google.maps) {
        const { AutocompleteService } = window.google.maps.places

        return new AutocompleteService()
      }
      return null
    },
  },
  created() {},
  methods: {
    async autocomplete(query) {
      if (!query.trim()) {
        this.options = []
        return
      }

      this.loading = true

      const searchParams = {
        input: query,
        componentRestrictions: {
          country: 'au',
        },
        types: ['geocode'],
      }

      this.autocomplete2.getPlacePredictions(searchParams, results => {
        if (!results) {
          this.options = []
          return
        }
        this.options = results.map(result => result.description)
      })

      this.loading = false
    },
  },
}
</script>

<template>
  <el-select
    v-model="selected"
    :remote-method="autocomplete"
    :loading="loading"
    placeholder=""
    filterable
    remote
  >
    <el-option
      v-for="(item, idx) in options"
      :key="idx"
      :label="item"
      :value="item"
    />
  </el-select>
</template>
